<template>
    <div>
    <v-card class="score-chart mx-1" v-if="!loading&&layoutType==='agent'">
        <v-card-title class="caption-font">
            <span class="caption-font white--text"><v-avatar size="40" class="change mr-4"><v-icon color="white">mdi-home-modern</v-icon></v-avatar>Accommodations with layout warnings: {{ layoutErrors.length }}</span>
            <v-spacer></v-spacer>
            <v-btn v-if="layoutErrors.length>0&&!showDetails" color="primary" text small v-on:click="showDetails = !showDetails" class="mr-10 white--text"><v-icon color="primary">mdi-arrow-down-bold-box-outline</v-icon> View list</v-btn>
            <v-btn v-if="layoutErrors.length>0&&showDetails"  color="primary" text small v-on:click="showDetails = !showDetails" class="mr-10 white--text"><v-icon color="primary">mdi-arrow-down-bold-box-outline</v-icon> Hide list</v-btn>
        </v-card-title>
        <v-card-text v-if="showDetails">
            <v-row class="ma-0 pa-0">
                <v-col cols="1" class="acconame ma-0 pa-0">
                    Accommodation
                </v-col>
                <v-col cols="4" class="acconame ma-0 pa-0">
                    Name
                </v-col>
                <v-col cols="1" class="acconame ma-0 pa-0">
                    Warnings
                </v-col>
                <v-col cols="5" class="acconame ma-0 pa-0">

                </v-col>
            </v-row>
            <v-row v-for="item in layoutErrors" :key="item.encrid" class="ma-0 pa-0">
                <v-col cols="1" class="ma-0 pa-0">
                    <span class="accolink blue--text text-decoration-underline" @click="openSubScreen('/huis/onhuis/' + item.encrid)">{{ item.acco }}</span>
                </v-col>
                <v-col cols="4" class="acconame ma-0 pa-0">
                    {{ item.oms }}
                </v-col>
                <v-col cols="1" class="acconame ma-0 pa-0">
                    {{ item.wrn }}
                </v-col>
                <v-col cols="5" class="acconame ma-0 pa-0">

                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
    <v-card class="score-chart mx-1" v-if="!loading&&layoutType==='control'">
        <v-card-title class="caption-font">
            <span class="caption-font white--text"><v-avatar size="40" class="change mr-4"><v-icon color="white">mdi-home-modern</v-icon></v-avatar>Rental experts with layout warnings: {{ layoutErrors1.length }}</span>
            <v-spacer></v-spacer>
            <v-btn v-if="layoutErrors1.length>0&&!showDetails1" color="primary" text small v-on:click="showDetails1 = !showDetails1" class="mr-10 white--text"><v-icon color="primary">mdi-arrow-down-bold-box-outline</v-icon> View list</v-btn>
            <v-btn v-if="layoutErrors1.length>0&&showDetails1"  color="primary" text small v-on:click="showDetails1 = !showDetails1" class="mr-10 white--text"><v-icon color="primary">mdi-arrow-down-bold-box-outline</v-icon> Hide list</v-btn>
        </v-card-title>
        <v-card-text v-if="showDetails1">
            <v-row  class="ma-0 pa-0">
                <v-col cols="3" class="listHeader bold ma-0 pa-0">
                    Expert
                </v-col>
                <v-col cols="1" class="listHeader ma-0 pa-0 text-right">
                    Warnings <v-icon class="pb-2">mdi-home-alert-outline</v-icon> 
                </v-col>
                <v-col cols="1" class="listHeader ma-0 pa-0 text-right">
                    Total <v-icon class="pb-2">mdi-home-outline</v-icon> 
                </v-col>
                <v-col cols="7" class="listHeader ma-0 pa-0">

                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row v-for="item in layoutErrors1" :key="item.Expert" class="ma-0 pa-0">
                <v-col cols="3" class="ma-0 pa-0">
                    <span>{{ item.Expert }}</span>
                </v-col>
                <v-col cols="1" class="acconame ma-0 pa-0 text-right">
                    {{ item.errors.length }}
                </v-col>
                <v-col cols="1" class="acconame ma-0 pa-0 text-right">
                    {{ item.huis_count }}
                </v-col>
                <v-col cols="6" class="acconame ma-0 pa-0">
                </v-col>
                <v-col cols="1" class="acconame ma-0 pa-0">
                    <v-btn v-if="item.errors.length>0&&!item.showErrors" color="primary" text small v-on:click="item.showErrors = !item.showErrors" class="mr-10 white--text"><v-icon color="primary">mdi-arrow-down-bold-box-outline</v-icon> View list</v-btn>
                    <v-btn v-if="item.errors.length>0&&item.showErrors"  color="primary" text small v-on:click="item.showErrors = !item.showErrors" class="mr-10 white--text"><v-icon color="primary">mdi-arrow-down-bold-box-outline</v-icon> Hide list</v-btn>
                </v-col>
                <v-col v-if="item.showErrors" class="ma-0 pa-0">
                    <v-divider></v-divider>
                    <v-row  class="ma-0 pa-0">
                        <v-col cols="1" class="listHeader ma-0 pa-0">
                            Accommodation
                        </v-col>
                        <v-col cols="3" class="listHeader ma-0 pa-0">
                            Name
                        </v-col>
                        <v-col cols="1" class="listHeader ma-0 pa-0 text-right">
                            Warnings
                        </v-col>
                        <v-col cols="7" class="listHeader ma-0 pa-0">

                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row v-for="error in item.errors" :key="error.encrid" class="ma-0 pa-0">
                        <v-col cols="1" class="ma-0 pa-0">
                            <span class="accolink blue--text text-decoration-underline" @click="openSubScreen('/huis/onhuis/' + error.encrid)">{{ error.acco }}</span>
                        </v-col>
                        <v-col cols="3" class="acconame ma-0 pa-0">
                            {{ error.oms }}
                        </v-col>
                        <v-col cols="1" class="acconame ma-0 pa-0 text-right">
                            {{ error.wrn }}
                        </v-col>
                        <v-col cols="7" class="acconame ma-0 pa-0">

                        </v-col>
                    </v-row>
                    <v-divider class="pb-4"></v-divider>
                </v-col>               
            </v-row>
        </v-card-text>

        <v-card-title class="caption-font">
            <span class="caption-font white--text"><v-avatar size="40" class="change mr-4"><v-icon color="white">mdi-home-modern</v-icon></v-avatar>Agents with layout warnings: {{ layoutErrors2.length }}</span>
            <v-spacer></v-spacer>
            <v-btn v-if="layoutErrors2.length>0&&!showDetails2" color="primary" text small v-on:click="showDetails2 = !showDetails2" class="mr-10 white--text"><v-icon color="primary">mdi-arrow-down-bold-box-outline</v-icon> View list</v-btn>
            <v-btn v-if="layoutErrors2.length>0&&showDetails2"  color="primary" text small v-on:click="showDetails2 = !showDetails2" class="mr-10 white--text"><v-icon color="primary">mdi-arrow-down-bold-box-outline</v-icon> Hide list</v-btn>
        </v-card-title>
        <v-card-text v-if="showDetails2">
            <v-row  class="ma-0 pa-0">
                <v-col cols="3" class="listHeader bold ma-0 pa-0">
                    Expert
                </v-col>
                <v-col cols="1" class="listHeader ma-0 pa-0 text-right">
                    Warnings <v-icon class="pb-2">mdi-home-alert-outline</v-icon> 
                </v-col>
                <v-col cols="1" class="listHeader ma-0 pa-0 text-right">
                    Total <v-icon class="pb-2">mdi-home-outline</v-icon> 
                </v-col>
                <v-col cols="7" class="listHeader ma-0 pa-0">

                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row v-for="item in layoutErrors2" :key="item.Expert" class="ma-0 pa-0">
                <v-col cols="3" class="ma-0 pa-0">
                    <span>{{ item.Expert }}</span>
                </v-col>
                <v-col cols="1" class="acconame ma-0 pa-0 text-right">
                    {{ item.errors.length }}
                </v-col>
                <v-col cols="1" class="acconame ma-0 pa-0 text-right">
                    {{ item.huis_count }}
                </v-col>
                <v-col cols="6" class="acconame ma-0 pa-0">
                </v-col>
                <v-col cols="1" class="acconame ma-0 pa-0">
                    <v-btn v-if="item.errors.length>0&&!item.showErrors" color="primary" text small v-on:click="item.showErrors = !item.showErrors" class="mr-10 white--text"><v-icon color="primary">mdi-arrow-down-bold-box-outline</v-icon> View list</v-btn>
                    <v-btn v-if="item.errors.length>0&&item.showErrors"  color="primary" text small v-on:click="item.showErrors = !item.showErrors" class="mr-10 white--text"><v-icon color="primary">mdi-arrow-down-bold-box-outline</v-icon> Hide list</v-btn>
                </v-col>
                <v-col v-if="item.showErrors" class="ma-0 pa-0">
                    <v-divider></v-divider>
                    <v-row  class="ma-0 pa-0">
                        <v-col cols="1" class="listHeader ma-0 pa-0">
                            Accommodation
                        </v-col>
                        <v-col cols="3" class="listHeader ma-0 pa-0">
                            Name
                        </v-col>
                        <v-col cols="1" class="listHeader ma-0 pa-0 text-right">
                            Warnings
                        </v-col>
                        <v-col cols="7" class="listHeader ma-0 pa-0">

                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row v-for="error in item.errors" :key="error.encrid" class="ma-0 pa-0">
                        <v-col cols="1" class="ma-0 pa-0">
                            <span class="accolink blue--text text-decoration-underline" @click="openSubScreen('/huis/onhuis/' + error.encrid)">{{ error.acco }}</span>
                        </v-col>
                        <v-col cols="3" class="acconame ma-0 pa-0">
                            {{ error.oms }}
                        </v-col>
                        <v-col cols="1" class="acconame ma-0 pa-0 text-right">
                            {{ error.wrn }}
                        </v-col>
                        <v-col cols="7" class="acconame ma-0 pa-0">

                        </v-col>
                    </v-row>
                    <v-divider class="pb-4"></v-divider>
                </v-col>               
            </v-row>
        </v-card-text>
    </v-card>
    </div>
</template>

<script>
    import {bus} from "../../../../main";

    export default {
        data() {
            return {
                layoutErrors: [],
                layoutErrors1: [],
                layoutErrors2: [],
                layoutType: "agent",
                showDetails: false,
                showDetails1: false,
                showDetails2: false,
                loading: true,
            }
        },
        created(){ // set up event bus listener here on created event
            this.getLayoutErrors();
            bus.$on("refresh", () => {
                this.getLayoutErrors();                
            });
        },                  
        methods:{
            getLayoutErrors(){  
                this.$axios.post("ares/json/ares/syst/dashboard/getLayoutErrors.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getLayoutErrors"
                    },
                    getLayoutErrors: {
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.layoutErrors = res.data.getLayoutErrors; 
                        this.layoutErrors1 = res.data.getLayoutErrors1; 
                        this.layoutErrors2 = res.data.getLayoutErrors2; 
                        this.layoutType = res.data.layoutType 
                        this.loading = false;  
                    }
                });
            }, 
            toggle() {
                this.showDetails = !this.showDetails
            },
            openSubScreen(path) {
                let route = this.$router.resolve({ path: path }); 
                window.open(route.href, '_blank');

            },          
        }
    }
</script>

<style scoped>
    .score-chart {
        background-image: linear-gradient(#A2A1ED, #DFDEF9) !important;
        background-size: cover !important;
    }

    .change {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid white;
        color: white;
        cursor: default;
    }

    .caption-font {
        font-size: 30px;
        font-weight: bold;
    }

    .accolink {
        cursor: pointer;
    }

    .acconame {
        cursor: default;
    }
    .listHeader {
        font-weight: bold;
    }
</style>